import React, { Component } from 'react'
import {Box, Button, Container, Divider, Grid, Typography,Checkbox, IconButton,TextField,MenuItem,Card} from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import {Paper} from '@mui/material'
import AppHeader from './AppHeader'
import StarIcon from '@mui/icons-material/Star';
import pent from '../src/vendor_assets/pent.jpg'
import SearchIcon from "@mui/icons-material/Search";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CallIcon from '@mui/icons-material/Call';


import Autocomplete from "react-google-autocomplete";


//////////// image details///////////////
import tt from '../src/vendor_assets/comp_img/1354.gif'
import ttt from '../src/vendor_assets/comp_img/24468.gif'
import tttt from '../src/vendor_assets/comp_img/29679.gif'
import ttttt from '../src/vendor_assets/comp_img/100007.gif'
import tttttt from '../src/vendor_assets/comp_img/144993.gif'
import ttttttt from '../src/vendor_assets/comp_img/314023.gif'
import tttttttt from '../src/vendor_assets/comp_img/719011.gif'
import ttttttttt from '../src/vendor_assets/comp_img/6344014.gif'
import Skeleton from '@mui/material/Skeleton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import AddIcon from '@mui/icons-material/Add';
import Diversity2Icon from '@mui/icons-material/Diversity2';

import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import { Global } from '@emotion/react';
import base from '../src/base.json'
import { useLocation, useNavigate, useParams } from 'react-router-dom';




const drawerBleeding = 56;
const api_key = "AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0";
const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: grey[100],
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.background.default,
  }),
}));

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.applyStyles('dark', {
    backgroundColor: grey[800],
  }),
}));




export class Secondpage extends Component {
  constructor(props) {
    super(props)
  
    this.state = { 
      category: "",
      location_name : "",
      sub_category : "",
    
      ////// is loader shows
     is_loader_open: true,
     open: false,
     page: 0,
     rowsPerPage : 25,
     vendor_count : 0,



     ///////////////// category lsit ///////////
     categoryList : [],
     subCategoryList : [],

     vendorList : []


      
    }
  }




  componentDidMount(){
    this.setState({
     location_name :  this.props.location.state?this.props.location.state.address : "", category:this.props.location.category?this.props.location.category.category_name : ""
    },()=>{
    fetch(
      `${base.base_url}/website/category/getCategoryList`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          categoryList: result.data,
        });
      });
  
/////////////// retrive vendor list /////////////

if(this.state.location_name==""){
  /// /getVendorListByFilterManual/:page/:rowsPerPage/:category/:sub_category
   fetch(
      `${base.base_url}/website/vendor/getVendorListByFilterManual/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.category}/:${this.state.sub_category}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
       )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          vendorList: result.data,
        });
      });

}else{

    fetch(
      `${base.base_url}/website/vendor/getVendorListByFilter/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.category}/:${this.state.sub_category}/:${this.state.location_name}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
       )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          vendorList: result.data,
        });
      }); 

}

  })}




makeSearch=()=>{
   if(this.state.location_name==""){
  /// /getVendorListByFilterManual/:page/:rowsPerPage/:category/:sub_category
   fetch(
      `${base.base_url}/website/vendor/getVendorListByFilterManual/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.category}/:${this.state.sub_category}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
       )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          vendorList: result.data,
          open : false
        });
      });

}else{

    fetch(
      `${base.base_url}/website/vendor/getVendorListByFilter/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.category}/:${this.state.sub_category}/:${this.state.location_name}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
       )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          vendorList: result.data,
            open : false
        });
      }); 

}
}


subCategoryList=(category_name)=>{

  fetch(
      `${base.base_url}/website/subCategory/getSubCategoryListForSelect/:${category_name}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          subCategoryList : result.data,
        });
      });
}
  



  render() {

    return (
      <div>
        <br/>
        <br/>
        <Box>
<Container maxWidth='xl'>
<Box sx={{mt:1}}>



<Grid container spacing={1}>
  <Grid size={{xs:12,sm:12,md:2.5}} sx={{display:{xs:'none',sm:'none',md:'block'}}}>
          <Paper variant='outlined' sx={{minHeight:600}}>

           <Paper
                                elevation={0}
                                sx={{
                                  backgroundColor: "#fff",
                                  minHeight: 500,
                                  width: "100%",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 17,
                                      fontWeight: "700",
                                      textTransform: "uppercase",
                                      color: "#1d294f",
                                      pl: 2,
                                      pt: 1,
                                      pb: 1,
                                      pt: 1,
                                    }}
                                  >
                                    Filter
                                  </Typography>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() =>
                                      this.setState({ category: "", sub_category: "", location_name:"" }, () => {
                                        this.makeSearch();
                                      })
                                    }
                                    disableElevation
                                    startIcon={<CloseIcon />}
                                    sx={{
                                      textTransform: "none",
                                      mr: 1,
                                      height: 25,
                                      backgroundColor: "#ab266c",
                                    }}
                                  >
                                    Clear Filter
                                  </Button>
                                </Box>
          
                                <Divider
                                  sx={{ backgroundColor: "#ab266c", ml: 0.5, mr: 0.5 }}
                                />
          
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    color: "#1d294f",
                                    ml: 2,
                                    mt: 2,
                                  }}
                                >
                                  Select Category
                                </Typography>


                                {
                                  this.state.categoryList.map((row,i)=>(
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "left",
                                    alignItems: "center",
                                    ml: 1,
                                    mt: 1,
                                  }}
                                >
                                  <Checkbox
                                    size="small"
                                    onClick={()=>this.setState({category:row.category_name,sub_category:"",subCategoryList:[]},()=>{
                                      this.subCategoryList(row.category_name);
                                      this.makeSearch();
                                    })}
                                    checked={
                                      this.state.category == row.category_name? true : false
                                    }
                                    
                                  />{" "}
                                  <Typography
                                    sx={{ fontSize: 12, textTransform: "uppercase" }}
                                  >
                                    {row.category_name}
                                  </Typography>
                                </Box>

                                  ))
                                }
          
                                
                                 <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',mt:1,mb:1}}>
                                  <Button size='small'  sx={{height:20,fontSize:11,fontWeight:'bold',display:'flex',justifyContent:'center'}}>View More</Button>
                                 </Box>
                                 
                                <Divider
                                  sx={{ backgroundColor: "#ab266c", ml: 0.5, mr: 0.5 }}
                                />
                                   
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    fontWeight: "700",
                                    textTransform: "uppercase",
                                    color: "#1d294f",
                                    ml: 2,
                                    mt: 2,
                                  }}
                                >
                                 Select Location
                                </Typography>

                                    {['PUNE','MUMBAI','KOLKATA','BANGLORE','NOIDA','DELHI','SURAT','AHAMDABAD'].slice(0,5).map((i)=>(

                                     <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "left",
                                        alignItems: "center",
                                        ml: 1,
                                      }}
                                    >
                                      <Checkbox
                                        onClick={()=>this.setState({location_name:i})}
                                        size="small"
                                        checked={this.state.location_name
                                         == i ? true : false}
                                        
                                      />{" "}
                                      <Typography
                                        sx={{ fontSize: 12, textTransform: "uppercase" }}
                                      >
                                        {i}
                                      </Typography>
                                    </Box> 

                                       ))
                                    }
                                
                             
                              </Paper>

                          </Paper>
                          <br/>
                          <br/>
   </Grid>




  <Grid size={{xs:12,sm:12,md:7}}>
   <Box sx={{minHeight:600}}>



    <Card elevation={1} sx={{mb:2,backgroundColor:'#fff',display:{xs:'block'}}}>
      
                  <Box sx={{ height: 60 }}>
                    <Grid container spacing={1}>
                      <Grid item sx={{display:{xs:'none',sm:'block'}}} size={{ xs: 3,sm:3,md:3}}>
                        <Box sx={{ display: "flex", justifyContent: "center",alignItems:'center'}}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItem: "center",
                              width: "100%",
                              ml:'20%',
                              justifyContent: "center",
                            }}
                          >

                            <TextField
                              id="outlined"
                              select
                             
                              fullWidth
                              defaultValue={this.state.sub_category}
                              variant="standard"

                              sx={{ width: "100%", 
                                height: 70, 
                                marginTop: 2.5,
                                fontSize:12 , 
                                textTransform:'uppercase',

                                '& .MuiSelect-select span::before': {
                                   content: "'-Select sub category-'",
                                 },


                              }}
                              InputProps={{
                                disableUnderline: "true", style:{fontSize:12}
                              }}
                            >
                              {this.state.subCategoryList.map((option) => (
                                <MenuItem
                                  key={option.sub_category_name}
                                  onClick={()=>this.setState({sub_category:option.sub_category_name},()=>{
                                    this.makeSearch();
                                  })}
                                  value={option.sub_category_name}
                                  sx={{fontSize:12,textTransform:'uppercase'}}
                                >
                                  {option.sub_category_name}
                                </MenuItem>
                              ))}
                            </TextField>

                          </Box>
                        </Box>
                      </Grid>
                      <Grid item sx={{display:{xs:'none',sm:'block'}}} size={{xs:1}}>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ height: "90%", marginLeft: 1, marginRight: 1 ,p:1}}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12,sm:8 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            marginTop: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItem: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "center",
                                marginLeft: 5,
                                marginRight: 1,
                              }}
                            >
                              <Autocomplete
                                apiKey={api_key}
                                defaultValue={this.state.location_name}
                                options={{
                                types: ["(cities)"],
                                  componentRestrictions: { country: 'in' },
                                       }}
                                onPlaceSelected={(place) =>
                                  
                                  this.setState({
                                    location_name: place
                                      ? place.address_components[0].long_name
                                      : "",
                                  })
                                }
                                style={{
                                  borderRadius: 5,
                                  border: "none",
                                  borderColor: "white",
                                  outline: "none",
                                  fontWeight:'bold',
                                  color:'#1e7ade',
                                  fontSize:12,
                                  textTransform:'uppercase',
                                  width: "100%",
                                }}
                              />

              
                              <IconButton  size='small' color="primary" sx={{backgroundColor:'#1e7ade',display:this.state.location_name!==""?'block':'none',mr:1}} aria-label="add to shopping cart" onClick={()=>this.setState({
                                    category : "",
                                    sub_category : "",
                                    location_name : ""
                                   },()=>{this.makeSearch()})}>
                                          <CloseIcon sx={{color:'red'}}/>
                              </IconButton>


                               <IconButton  size='small' color="primary" sx={{backgroundColor:'#1e7ade'}} aria-label="add to shopping cart" onClick={this.makeSearch}>
                                          <SearchIcon sx={{color:'#fff'}}/>
                               </IconButton>
                              
                            </Box>
                          </Box>


                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

    </Card>



{
  //// above search 
}
      
   
{
  this.state.vendorList.map((e)=>(
   <Paper elevation={0} sx={{minHeight:200,width:'100%',backgroundColor:'#fff',borderRadius:3,mt:1}}>
        <Box sx={{p:3}}>


           <Grid container spacing={2}> 
            
            <Grid size={{xs:12,sm:12,md:3}}>
                <Box sx={{height:150,width:"100%",display:'flex',justifyContent:'center',alignItems:'center',borderRadius:3,border:1,borderColor:'#f0f0f0'}}>
                     <img src={base.base_url+'/'+e.vendors_thumb_nails_img} style={{height:150,width:"100%",borderRadius:8}}/>
                </Box>

              </Grid>

              <Grid size={{xs:12,sm:12,md:9}}>

          <Typography sx={{fontSize:17,fontWeight:'700'}}>{e.business_name}</Typography>
           <Box sx={{display:'flex',flexDirection:'row',alignItems:'center'}}>
              <Typography sx={{fontSize:12,mt:0.5,fontWeight:'600',width:'70%'}}>{e.bussiness_category} - {Math.floor(Math.random() * 5000)} Reviews</Typography>
              <StarIcon sx={{color:'#ff7d1e',ml:0.5,height:13,width:13,mt:0.5}}/> 
              <Typography sx={{ml:0.5,mt:0.5}}>|</Typography>
              <Typography sx={{fontSize:12,mt:0.5,ml:0.5,fontWeight:'600'}}>{Math.floor(Math.random() * 5)} Ratings</Typography>
           </Box>


            <Box sx={{mb:1,mt:0.5}}>
             <Box sx={{display:'flex',flexDirection:'row',alignItems:'center',mt:1}}>
             <AccessTimeIcon sx={{color:'#ff7d1e',ml:0.5,height:15,width:15,mt:0.5}}/> 
             <Typography sx={{ml:0.5,mt:0.5,fontSize:14}}>No fixed duration</Typography>

                  <Typography sx={{ml:1,mr:1}}>|</Typography>

               <CurrencyRupeeIcon sx={{color:'#ff7d1e',ml:0.5,height:15,width:15,mt:0.5}}/> 
               <Typography sx={{ml:0.5,mt:0.5,fontSize:14}}>Unpaid</Typography>

                  <Typography sx={{ml:1,mr:1}}>|</Typography>

               <LocationPinIcon sx={{color:'#ff7d1e',ml:0.5,height:15,width:15,mt:0.5}}/> 
               <Typography sx={{ml:0.5,mt:0.5,fontSize:14}}>{e.vender_personal_city}</Typography>

              </Box>

            </Box>
 
               <Typography sx={{fontSize:10,fontWeight:500,color:'#1e73c7',p:1,textTransform:'uppercase'}}>{e.vender_personal_address}</Typography>
             
             <Divider/>

<Box sx={{display:'flex',flexDirection:'row',mt:2}}>
<Button   onClick={() =>window.open(`/venderDesc/:${e.vendor_id}`)} endIcon={<CallIcon/>} variant='outlined' size='small' sx={{fontSize:{xs:10,sm:11},borderRadius:3}}>
contact us
</Button>

<Button onClick={() =>window.open(`/venderDesc/:${e.vendor_id}`)} disableElevation variant='contained' endIcon={<ArrowForwardIcon/>} size='small' sx={{ml:2,fontSize:{xs:10,sm:11},borderRadius:3}}>
More Information
</Button>

</Box>


              </Grid>

           </Grid>

      
        </Box>
      </Paper>  
  ))
}
      

      



    </Box>
  </Grid>


  


  <Grid size={{xs:12,sm:12,md:2.5}}>
   <Box sx={{minHeight:200}}>
     <Paper variant='outlined' sx={{minHeight:300,width:'100%',color:'#fff',borderRadius:3,mb:1}}>
      <Typography sx={{fontSize:13,p:2,color:'grey'}}>See 37 vendor listed on this portal</Typography>
        <Box sx={{pl:2,pr:2}}>
       <Grid container spacing={1}>
          <Grid size={{xs:6}}>
            <img src={tt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={ttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={tttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={ttttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={tttttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={ttttttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
             <Grid size={{xs:6}}>
            <img src={ttttttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>
            <Grid size={{xs:6}}>
            <img src={ttttttttt} style={{height:50,width:'100%',objectFit:'contain'}}/>
          </Grid>



       </Grid>

</Box>

     </Paper>


     





    </Box>
  </Grid>

</Grid>




</Box>
</Container>













        </Box>




{
  /////  drawer bottom
} 





<Box sx={{display:{xs:'flex',sm:'flex',md:'none'},position:'fixed',bottom:0,left:0,right:0,minHeight:50,width:'100%'}}>
<Paper elevation={5} sx={{height:55,width:'100%',borderTop:0.5,borderColor:'#3373b2',display:'flex',alignItems:'center',justifyContent:'space-between',flexDirection:'row'}}>



<IconButton color="primary" size='large' aria-label="filter docs" sx={{height:30,mr:2}} onClick={()=>this.setState({open:true})}>
  <FilterAltOutlinedIcon sx={{height:35,width:35}}/>
</IconButton>


<Button size='small' variant='contained' sx={{mr:2,fontSize:11}}>Home</Button>


</Paper>
</Box>





<Box>
<Root>
      <CssBaseline />
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: '100%',
            overflow: 'visible',
          },
        }}
      />
      <SwipeableDrawer
       // container={container}
        anchor="top"
        open={this.state.open}
        onClose={this.toggleDrawerr}
        onOpen={this.toggleDrawer}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
          }}
        >
  
        </StyledBox>


        <StyledBox sx={{  pb: 2, height: '100%', overflow: 'auto' }}>


           <Box sx={{height:60,width:'100%',display:'flex',alignItems:'center'}}>
                   <Typography sx={{fontSize:22,fontWeight:'600',color:'grey',ml:2}}>Filter Result</Typography>
                </Box>

         <Divider/>


          <Box sx={{width:'100%',height:'100%',display:'flex',flexDirection:'row'}}>

            
         
                  <Box sx={{width:'45%',height:'100%',backgroundColor:'#f8f8f8'}}>
                   <br/>




                      {
                        this.state.categoryList.map((row,i)=>(
                     <Box>
                     <Divider/>
                     <Box sx={{height:40,width:'100%',display:'flex',justifyContent:'left',alignItems:'left',borderLeft:this.state.category==row.category_name?4:0,borderColor:'#66b4da'}}>
                     <Button   onClick={()=>this.setState({category:row.category_name,sub_category:"",subCategoryList:[]},()=>{
                                      this.subCategoryList(row.category_name);
                                    })} variant="text" size='small' sx={{fontSize:10,textAlign:'left'}}>{row.category_name}</Button>
                     </Box>
                     </Box>
                        ))
                      }
                      
                  


            
            




                  </Box>


                  <Box sx={{width:'55%',height:'100%',}}>

                      
                       <br/>
                          
                          {
                            this.state.subCategoryList.map((row,i)=>(
                              <Box onClick={()=>this.setState({sub_category:row.sub_category_name})} sx={{height:40,width:'100%',display:'flex',justifyContent:'left',alignItems:'left',flexDirection:'row'}}>
                       <Checkbox checked={this.state.sub_category==row.sub_category_name?true:false} size='small'/>  <Button variant="text" size='small' sx={{fontSize:9,ml:-0.9}}>{row.sub_category_name}</Button>
                     </Box> 
                            ))
                          }

                  </Box>
          </Box>

             
      
         <Paper elevation={2} sx={{height:60,display:'flex',position:'absolute',bottom:0,left:0,right:0,justifyContent:'right',alignItems:'center'}}>
           <Button  variant="contained" sx={{height:30,mr:2}}  onClick={this.makeSearch}>Apply</Button>

           <Button color='error' variant="contained" sx={{height:30,mr:2}} onClick={()=>this.setState({open:false,
      category: "",
      location_name : "",
      sub_category : "",
           },()=>{this.makeSearch()})}>Cancel</Button>
         </Paper>


        </StyledBox>
      </SwipeableDrawer>
    </Root>
</Box>




      </div>
    )
  }
}

export default Secondpage

export function Secondpagec(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<Secondpage param={param} location={location} navigate={navigate}></Secondpage>)}




const SubCategory = [
  {
    value: "SUB CATEGORY",
    label: "SUB CATEGORY",
  },
  {
    value: "MUMBAI",
    label: "MUMBAI",
  },
  {
    value: "KOLKATTA",
    label: "KOLKATA",
  },
  {
    value: "NOIDA",
    label: "NOIDA",
  },
];